import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  CollectionReference,
  DocumentData,
  Timestamp,
  collectionGroup,
} from '@angular/fire/firestore';
import { addDays } from 'date-fns';
import { from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LeaseService {
  private leasesRef: CollectionReference<DocumentData>;

  constructor(private firestore: Firestore) {
    this.leasesRef = collection(this.firestore, 'leases');
  }

  async getLeasesByTenant(tenantId: string) {
    const q = query(this.leasesRef, where('tenantId', '==', tenantId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  }

  async addLease(leaseData: any) {
    return addDoc(this.leasesRef, leaseData);
  }

  getLeasesEndingSoon(days = 30) {
    const now = new Date();
    const future = addDays(now, days);
    const nowTs = Timestamp.fromDate(now);
    const futureTs = Timestamp.fromDate(future);

    const q = query(
      collectionGroup(this.firestore, 'leases'),
      where('endDate', '>=', nowTs),
      where('endDate', '<=', futureTs)
    );

    return from(getDocs(q)).pipe(
      map(snapshot => snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    );
  }
}
